
import React from 'react';
import Icon from './index';

const vectors = 'M9.81929129,4 L5.22801201,4 C4.84281081,4 4.5304985,4.31231231 4.5304985,4.69741742 L4.5304985,19.2614535 C4.5304985,19.6466547 4.84281081,19.958967 5.22801201,19.958967 L9.81929129,19.958967 C10.2044925,19.958967 10.5168048,19.6466547 10.5168048,19.2614535 L10.5168048,4.69741742 C10.5168048,4.31226426 10.2044925,4 9.81929129,4 Z M9.12192192,18.563988 L5.92538138,18.563988 L5.92538138,5.39488288 L9.12192192,5.39488288 L9.12192192,18.563988 Z M18.7308589,4 L14.1403003,4 C13.7550511,4 13.4427387,4.31231231 13.4427387,4.69741742 L13.4427387,19.2614535 C13.4427387,19.6466547 13.7550511,19.958967 14.1403003,19.958967 L18.7308589,19.958967 C19.116012,19.958967 19.4284204,19.6466547 19.4284204,19.2614535 L19.4284204,4.69741742 C19.4283243,4.31226426 19.116012,4 18.7308589,4 Z M18.0335375,18.563988 L14.8376697,18.563988 L14.8376697,5.39488288 L18.0335375,5.39488288 L18.0335375,18.563988 Z';

export default function Pause(props) {
  return (
    <Icon {...props} viewBox="0 0 24 24" vectors={vectors} />
  );
}

